const UP = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70];
const LO = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102];
const groups = [
  [0, 8],
  [9, 13],
  [14, 18],
  [19, 23],
  [24, 36],
];
const upper = false;
const lut = upper ? UP : LO;

export const uuidParser = (src: DataView): string => {
  const dst = Buffer.alloc(36);

  let i = 0;
  let group_idx = 0;
  while (group_idx < 5) {
    const group = groups[group_idx];
    const start = group[0];
    const end = group[1];

    let j = start;
    while (j < end) {
      const x = src.getUint8(i);
      i += 1;

      dst[j] = lut[x >> 4];
      dst[j + 1] = lut[x & 0x0f];
      j += 2;
    }

    if (group_idx < 4) {
      dst[end] = 45; // '-'
    }

    group_idx += 1;
  }

  return dst.toString();
};
